import script from "./AiBoke.vue?vue&type=script&setup=true&lang=js"
export * from "./AiBoke.vue?vue&type=script&setup=true&lang=js"

import "./AiBoke.vue?vue&type=style&index=0&id=05675bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05675bf2"]])

export default __exports__